import { Button } from "./Button";
import { Sheet } from "./Sheet";

interface SubmitMockSheetProps {
  /** 1-based question numbers still blank. */
  unanswered: number[];
  onGoToUnanswered: () => void;
  onSubmit: () => void;
  onDismiss: () => void;
}

/** `[5, 9, 14]` → "5, 9 and 14" — the comp names them rather than counting. */
function listNumbers(numbers: number[]): string {
  if (numbers.length === 1) return String(numbers[0]);
  return `${numbers.slice(0, -1).join(", ")} and ${numbers[numbers.length - 1]}`;
}

/**
 * S11vSubmit — names the blanks and gives the exam-room advice.
 *
 * "A guess beats a blank in JAMB" is true and actionable: there is no negative
 * marking, so a blank is strictly worse than a guess. Telling a student that at
 * the moment they are about to submit is worth more than a confirmation dialog.
 */
export function SubmitMockSheet({
  unanswered,
  onGoToUnanswered,
  onSubmit,
  onDismiss,
}: SubmitMockSheetProps) {
  return (
    <Sheet
      title={`Submit with ${unanswered.length} unanswered?`}
      onDismiss={onDismiss}
      actions={
        <>
          <Button onClick={onGoToUnanswered}>Go to unanswered</Button>
          <Button variant="ghost" onClick={onSubmit}>
            Submit anyway
          </Button>
        </>
      }
    >
      <p className="tabular m-0 text-[13.5px] leading-[1.55] text-text-muted">
        {unanswered.length === 1 ? "Question" : "Questions"} {listNumbers(unanswered)}{" "}
        {unanswered.length === 1 ? "is" : "are"} still blank. Unanswered questions score zero — a
        guess beats a blank in JAMB.
      </p>
    </Sheet>
  );
}
